import { MapPinned, PanelsTopLeft, ShoppingCart, LayoutTemplate } from 'lucide-react'

export const prompts = [
  {
    name: 'Restaurant delivery platform',
    prompt:
      () => `Build me a delivery platform that looks like Bolt Food Poland (https://bolt.eu/pl-pl/food/).
It should display a list of restaurants with a type of cuisine, rating, distance, delivery fees.
Each restaurant has its own page with a menu. Each item in the menu needs a price, title, description and picture.
The user can add items to the cart and pass the order to the restaurant.

I live in Cracow, Poland.

We want to store the data (restaurants, menu, clients, orders, etc.) in PostgreSQL.
There should be at least 20 restaurants and each one should have at least 10 menu items. The restaurant should have a real address in Cracow.
On the main page we should see a map with pins to locate the available restaurants. When we click on a pin, we should be redirected to the restaurant's page.`,
    icon: MapPinned,
  },
  {
    name: 'Reproduce a website',
    prompt: () =>
      `Reproduce the web page at ${rollProspect().url} in React using Next.js, shadcn, and Tailwind CSS.`,
    icon: PanelsTopLeft,
  },

  {
    name: 'E-commerce',
    icon: ShoppingCart,
    prompt:
      () => `We want to create an ecommerce shop's demonstration that reproduce the branding of our prospect, North Face. Their website is https://www.thenorthface.com/en-us

We want:
1. the main page should display some marketing content
2. a page with the list of categories with at least two categories of products
3. for each category, a page with at least 3 products per categories

The whole website and content should be branded like the prospect.`,
  },
  {
    name: 'Landing page',
    prompt: getLandingPagePrompt,
    icon: LayoutTemplate,
  },
]

function getLandingPagePrompt() {
  const { name, url } = rollProspect()

  return `Build a Marketing Landing Page for my prospect ${name} (${url}). Use Shadcn, and a NextJS. It should have a nice hero image at the top taking up the full width. Underneath the hero image it should contain nicely designed images in a flex grid layout where its alternating pictures of products with slogans.`
}

function rollProspect() {
  const prospects = [
    {
      name: 'Nike',
      url: 'www.nike.com',
      category: 'Fashion and Lifestyle',
    },
    {
      name: 'Adidas',
      url: 'www.adidas.com',
      category: 'Fashion and Lifestyle',
    },
    {
      name: 'Stussy',
      url: 'www.stussy.com',
      category: 'Fashion and Lifestyle',
    },
    {
      name: 'Supreme',
      url: 'www.supremenewyork.com',
      category: 'Fashion and Lifestyle',
    },
    {
      name: 'Uniqlo',
      url: 'www.uniqlo.com',
      category: 'Fashion and Lifestyle',
    },
    {
      name: 'Zara',
      url: 'www.zara.com',
      category: 'Fashion and Lifestyle',
    },
    {
      name: 'H&M',
      url: 'www.hm.com',
      category: 'Fashion and Lifestyle',
    },
    {
      name: 'House of Hackney',
      url: 'www.houseofhackney.com',
      category: 'Fashion and Lifestyle',
    },
    {
      name: 'Gucci',
      url: 'www.gucci.com',
      category: 'Fashion and Lifestyle',
    },
    {
      name: 'Louis Vuitton',
      url: 'www.louisvuitton.com',
      category: 'Fashion and Lifestyle',
    },
    {
      name: 'The North Face',
      url: 'www.thenorthface.com',
      category: 'Fashion and Lifestyle',
    },
    {
      name: 'Patagonia',
      url: 'www.patagonia.com',
      category: 'Fashion and Lifestyle',
    },
    {
      name: 'Urban Outfitters',
      url: 'www.urbanoutfitters.com',
      category: 'Fashion and Lifestyle',
    },
    {
      name: 'Anthropologie',
      url: 'www.anthropologie.com',
      category: 'Fashion and Lifestyle',
    },
    {
      name: 'ASOS',
      url: 'www.asos.com',
      category: 'Fashion and Lifestyle',
    },
    {
      name: 'Aldi',
      url: 'www.aldi.com',
      category: 'Supermarkets and Retail Chains',
    },
    {
      name: 'Lidl',
      url: 'www.lidl.com',
      category: 'Supermarkets and Retail Chains',
    },
    {
      name: 'Tesco',
      url: 'www.tesco.com',
      category: 'Supermarkets and Retail Chains',
    },
    {
      name: 'Walmart',
      url: 'www.walmart.com',
      category: 'Supermarkets and Retail Chains',
    },
    {
      name: 'Target',
      url: 'www.target.com',
      category: 'Supermarkets and Retail Chains',
    },
    {
      name: 'Carrefour',
      url: 'www.carrefour.com',
      category: 'Supermarkets and Retail Chains',
    },
    {
      name: 'Costco',
      url: 'www.costco.com',
      category: 'Supermarkets and Retail Chains',
    },
    {
      name: 'Kroger',
      url: 'www.kroger.com',
      category: 'Supermarkets and Retail Chains',
    },
    {
      name: "Sainsbury's",
      url: 'www.sainsburys.co.uk',
      category: 'Supermarkets and Retail Chains',
    },
    {
      name: 'Whole Foods',
      url: 'www.wholefoodsmarket.com',
      category: 'Supermarkets and Retail Chains',
    },
    {
      name: 'Media Markt',
      url: 'www.mediamarkt.de',
      category: 'Electronics and Technology',
    },
    {
      name: 'Best Buy',
      url: 'www.bestbuy.com',
      category: 'Electronics and Technology',
    },
    {
      name: 'Apple',
      url: 'www.apple.com',
      category: 'Electronics and Technology',
    },
    {
      name: 'Samsung',
      url: 'www.samsung.com',
      category: 'Electronics and Technology',
    },
    {
      name: 'Sony',
      url: 'www.sony.com',
      category: 'Electronics and Technology',
    },
    {
      name: 'Microsoft',
      url: 'www.microsoft.com',
      category: 'Electronics and Technology',
    },
    {
      name: 'Dell',
      url: 'www.dell.com',
      category: 'Electronics and Technology',
    },
    {
      name: 'HP',
      url: 'www.hp.com',
      category: 'Electronics and Technology',
    },
    {
      name: 'LG',
      url: 'www.lg.com',
      category: 'Electronics and Technology',
    },
    {
      name: 'Lenovo',
      url: 'www.lenovo.com',
      category: 'Electronics and Technology',
    },
    {
      name: 'John Deere',
      url: 'www.deere.com',
      category: 'Agriculture and Equipment',
    },
    {
      name: 'Caterpillar',
      url: 'www.cat.com',
      category: 'Agriculture and Equipment',
    },
    {
      name: 'Kubota',
      url: 'www.kubota.com',
      category: 'Agriculture and Equipment',
    },
    {
      name: 'Case IH',
      url: 'www.caseih.com',
      category: 'Agriculture and Equipment',
    },
    {
      name: 'New Holland',
      url: 'www.newholland.com',
      category: 'Agriculture and Equipment',
    },
    {
      name: 'Massey Ferguson',
      url: 'www.masseyferguson.com',
      category: 'Agriculture and Equipment',
    },
    {
      name: 'CLAAS',
      url: 'www.claas.com',
      category: 'Agriculture and Equipment',
    },
    {
      name: 'AGCO',
      url: 'www.agco.com',
      category: 'Agriculture and Equipment',
    },
    {
      name: 'Fendt',
      url: 'www.fendt.com',
      category: 'Agriculture and Equipment',
    },
    {
      name: 'Vermeer',
      url: 'www.vermeer.com',
      category: 'Agriculture and Equipment',
    },
    {
      name: 'IKEA',
      url: 'www.ikea.com',
      category: 'Home and Furniture',
    },
    {
      name: 'Wayfair',
      url: 'www.wayfair.com',
      category: 'Home and Furniture',
    },
    {
      name: 'Crate & Barrel',
      url: 'www.crateandbarrel.com',
      category: 'Home and Furniture',
    },
    {
      name: 'West Elm',
      url: 'www.westelm.com',
      category: 'Home and Furniture',
    },
    {
      name: 'Pottery Barn',
      url: 'www.potterybarn.com',
      category: 'Home and Furniture',
    },
    {
      name: 'Restoration Hardware',
      url: 'www.rh.com',
      category: 'Home and Furniture',
    },
    {
      name: 'CB2',
      url: 'www.cb2.com',
      category: 'Home and Furniture',
    },
    {
      name: 'Article',
      url: 'www.article.com',
      category: 'Home and Furniture',
    },
    {
      name: 'HomeGoods',
      url: 'www.homegoods.com',
      category: 'Home and Furniture',
    },
    {
      name: 'Ethan Allen',
      url: 'www.ethanallen.com',
      category: 'Home and Furniture',
    },
    {
      name: "Dick's Sporting Goods",
      url: 'www.dickssportinggoods.com',
      category: 'Sporting Goods',
    },
    {
      name: 'REI',
      url: 'www.rei.com',
      category: 'Sporting Goods',
    },
    {
      name: 'Decathlon',
      url: 'www.decathlon.com',
      category: 'Sporting Goods',
    },
    {
      name: 'Under Armour',
      url: 'www.underarmour.com',
      category: 'Sporting Goods',
    },
    {
      name: 'Puma',
      url: 'www.puma.com',
      category: 'Sporting Goods',
    },
    {
      name: 'New Balance',
      url: 'www.newbalance.com',
      category: 'Sporting Goods',
    },
    {
      name: 'Columbia',
      url: 'www.columbia.com',
      category: 'Sporting Goods',
    },
    {
      name: 'Asics',
      url: 'www.asics.com',
      category: 'Sporting Goods',
    },
    {
      name: 'Fila',
      url: 'www.fila.com',
      category: 'Sporting Goods',
    },
    {
      name: 'Reebok',
      url: 'www.reebok.com',
      category: 'Sporting Goods',
    },
    {
      name: 'Sephora',
      url: 'www.sephora.com',
      category: 'Beauty and Personal Care',
    },
    {
      name: 'Ulta',
      url: 'www.ulta.com',
      category: 'Beauty and Personal Care',
    },
    {
      name: 'MAC Cosmetics',
      url: 'www.maccosmetics.com',
      category: 'Beauty and Personal Care',
    },
    {
      name: "L'Oréal",
      url: 'www.loreal.com',
      category: 'Beauty and Personal Care',
    },
    {
      name: 'Estée Lauder',
      url: 'www.esteelauder.com',
      category: 'Beauty and Personal Care',
    },
    {
      name: 'Bath & Body Works',
      url: 'www.bathandbodyworks.com',
      category: 'Beauty and Personal Care',
    },
    {
      name: 'The Body Shop',
      url: 'www.thebodyshop.com',
      category: 'Beauty and Personal Care',
    },
    {
      name: 'Glossier',
      url: 'www.glossier.com',
      category: 'Beauty and Personal Care',
    },
    {
      name: "Kiehl's",
      url: 'www.kiehls.com',
      category: 'Beauty and Personal Care',
    },
    {
      name: 'Lush',
      url: 'www.lush.com',
      category: 'Beauty and Personal Care',
    },
    {
      name: 'Nordstrom',
      url: 'www.nordstrom.com',
      category: 'Department Stores',
    },
    {
      name: "Macy's",
      url: 'www.macys.com',
      category: 'Department Stores',
    },
    {
      name: "Bloomingdale's",
      url: 'www.bloomingdales.com',
      category: 'Department Stores',
    },
    {
      name: 'Harrods',
      url: 'www.harrods.com',
      category: 'Department Stores',
    },
    {
      name: 'Selfridges',
      url: 'www.selfridges.com',
      category: 'Department Stores',
    },
    {
      name: 'Galeries Lafayette',
      url: 'www.galerieslafayette.com',
      category: 'Department Stores',
    },
    {
      name: 'El Corte Inglés',
      url: 'www.elcorteingles.es',
      category: 'Department Stores',
    },
    {
      name: 'John Lewis',
      url: 'www.johnlewis.com',
      category: 'Department Stores',
    },
    {
      name: 'Marks & Spencer',
      url: 'www.marksandspencer.com',
      category: 'Department Stores',
    },
    {
      name: 'Harvey Nichols',
      url: 'www.harveynichols.com',
      category: 'Department Stores',
    },
    {
      name: 'Home Depot',
      url: 'www.homedepot.com',
      category: 'DIY and Home Improvement',
    },
    {
      name: "Lowe's",
      url: 'www.lowes.com',
      category: 'DIY and Home Improvement',
    },
    {
      name: 'B&Q',
      url: 'www.diy.com',
      category: 'DIY and Home Improvement',
    },
    {
      name: 'Wickes',
      url: 'www.wickes.co.uk',
      category: 'DIY and Home Improvement',
    },
    {
      name: 'Ace Hardware',
      url: 'www.acehardware.com',
      category: 'DIY and Home Improvement',
    },
    {
      name: 'Menards',
      url: 'www.menards.com',
      category: 'DIY and Home Improvement',
    },
    {
      name: 'Bunnings',
      url: 'www.bunnings.com.au',
      category: 'DIY and Home Improvement',
    },
    {
      name: 'Leroy Merlin',
      url: 'www.leroymerlin.fr',
      category: 'DIY and Home Improvement',
    },
    {
      name: 'Hornbach',
      url: 'www.hornbach.com',
      category: 'DIY and Home Improvement',
    },
    {
      name: 'OBI',
      url: 'www.obi.com',
      category: 'DIY and Home Improvement',
    },
    {
      name: 'Saks Fifth Avenue',
      url: 'www.saksfifthavenue.com',
      category: 'Luxury Department Stores',
    },
    {
      name: 'Neiman Marcus',
      url: 'www.neimanmarcus.com',
      category: 'Luxury Department Stores',
    },
    {
      name: 'Bergdorf Goodman',
      url: 'www.bergdorfgoodman.com',
      category: 'Luxury Department Stores',
    },
    {
      name: 'Liberty London',
      url: 'www.libertylondon.com',
      category: 'Luxury Department Stores',
    },
    {
      name: 'Lane Crawford',
      url: 'www.lanecrawford.com',
      category: 'Luxury Department Stores',
    },
  ]

  return prospects[Math.floor(Math.random() * prospects.length)]
}
